import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

import apiaxios from 'axios'

import router from './router'

import config from './app_settings'

/** Conexión hacia Back End
 */
apiaxios.defaults.baseURL = config.back.url
apiaxios.defaults.headers.common['Authorization'] = ''
apiaxios.defaults.headers.post['Content-Type'] = 'application/json'
apiaxios.defaults.crossdomain = true

Vue.use(Vuex)

/** Constante para el manejo del storage
 */
const vuexLocalStorage = new VuexPersist({
  key: 'vd',
  storage: window.sessionStorage,
  reducer: state => ({
    user: state.user,
    projects: state.projects,
    routes: state.routes,
    actualProject: state.actualProject,
    actualOperation: state.actualOperation,
    drawerOptions: state.drawerOptions
  })
})

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',

  state: {
    layout: 'login-layout',
    drawer: true,
    pretoken: 'IK ',
    token: null,
    status: false,

    user: null,
    projects: null,
    routes: null,
    actualProject: null,
    actualRole: null,
    actualOperation: null,
    drawerOptions: null,
    appConf: config,

    options: [],
    userOptions: [
      {
        title: 'Dashboard',
        icon: 'assignment',
        path: '/report/dashboardoperational'
      },
      {
        title: 'Avance',
        icon: 'trending_up',
        path: '/report/progress'
      },
      {
        title: 'Frecuencia',
        icon: 'multiline_chart',
        path: '/report/frequency'
      },
      {
        title: 'Multiple',
        icon: 'multiline_chart',
        path: '/report/multiple'
      },
      {
        title: 'Encuestador',
        icon: 'assignment_ind',
        path: '/report/pollster'
      },
      {
        title: 'Mapa',
        icon: 'room',
        path: '/report/mapleaflet'
      },
      {
        title: 'Audios Callcenter',
        icon: 'audiotrack',
        path: '/report/audioreport'
      },
      {
        title: 'Validar Direcciones',
        icon: 'room',
        path: '/report/validateaddress'
      },
      {
        title: 'Validar Audios',
        icon: 'audiotrack',
        path: '/report/validaterecords'
      }
      // {
      //   title: 'Audios',
      //   icon: 'audiotrack',
      //   path: '/records',
      //   ignore: ['CL']
      // }
    ],
    adminOptions: {
      title: 'Gestión',
      icon: 'settings',
      items: [
        {
          title: 'Personal',
          icon: 'supervisor_account',
          path: '/manage/staff',
          allow: ['A']
        },
        {
          title: 'Proyectos',
          icon: 'monetization_on',
          path: '/manage/projects',
          allow: ['A']
        },
        {
          title: 'Operativos de proyectos',
          icon: 'bubble_chart',
          path: '/manage/projectoperation',
          allow: ['A']
        },
        {
          title: 'Grupos de operativo',
          icon: 'group_work',
          path: '/manage/groups',
          allow: ['A']
        },
        {
          title: 'Personal del proyecto',
          icon: 'contacts',
          path: '/manage/projectstaff',
          allow: ['A']
        },
        {
          title: 'Rastreador Móvil',
          icon: 'phone',
          path: '/manage/tracker-movil',
          allow: ['A', 'OP']
        }
      ]
    },
    testing: [
      {
        title: 'EN PRUEBAS',
        icon: 'bug_report',
        items: [
          {
            title: 'Reporte Audios',
            icon: 'audiotrack',
            path: '/report/audioreport'
          },
          {
            title: 'Reporte de Baños',
            icon: 'spa',
            path: '/ik/restrooms'
          },
          {
            title: 'Extracción'
          },
          {
            title: 'Formularios',
            icon: 'assignment',
            path: '/integration/Forms'
          },
          {
            title: 'Lime Survey',
            icon: 'sync_alt',
            path: '/integration/LimeSurvey'
          },
          {
            title: 'GENERICAS'
          },
          {
            title: 'Frecuencia',
            icon: 'multiline_chart',
            path: '/report/frequency'
          },
          {
            title: 'Multiple',
            icon: 'multiline_chart',
            path: '/report/multiple'
          },
          {
            title: 'Metabase',
            icon: 'multiline_chart',
            path: '/report/metabase'
          },
          {
            title: 'MapLeaflet',
            icon: 'room',
            path: '/report/mapleaflet'
          },
          {
            title: 'MapaDistancia',
            icon: 'room',
            path: '/report/mapadistancia'
          }
        ]
      }
    ]
  },

  plugins: [
    vuexLocalStorage.plugin
  ],

  mutations: {
    /** Determina el layout a usar en cada vista */
    SET_LAYOUT (state, newLayout) {
      state.layout = newLayout
    },

    /** Modifia el estado de drawer visible u oculto */
    toggle_drawer (state, toggle) {
      state.drawer = toggle
    },

    /** Funciones encargadas de la autenticación y datos asociados */
    auth_success (state, token) {
      state.status = true
      state.token = token
    },
    auth_error (state, error) {
      state.status = { 'error': error }
    },
    logout (state) {
      state.status = false
      state.token = null

      state.user = null
      state.projects = null
      state.routes = null
      state.actualProject = null
      state.drawerOptions = null
    },

    /** Carga el usuario a usar
     * actualiza las opciones del drawer con los valores respectivos
     */
    set_user_info (state, data) {
      state.user = data

      // Si el usuario es admin le da los permisos FIXME
      // if (data.cedula === 'admin') {
      //   state.actualRole = 'A'
      // }

      // Si el usuario es admin le da los permisos FIXME
      if (data.cedula === '24989782') {
        state.actualRole = 'CIK'
      }

      state.options = []

      if (state.appConf.back.toolbarMsg) {
        state.options = [
          { header: state.appConf.back.toolbarMsg },
          { divider: true, inset: true }
        ]
      }

      // Elementos en Prueba
      // if (state.actualRole === 'A') {
      //   state.options.push(state.testing)
      // }

      // Debe cargar cuando el rol sea Claudia
      if (data.cedula === '24989782') {
        state.options.push(
          {
            title: 'Reporte de Baños',
            icon: 'spa',
            path: '/ik/restrooms'
          }
        )
      }

      // Si se tienen permisos administrativos
      // if (state.actualRole === 'A') {
      //   let canAdmin = JSON.parse(JSON.stringify(state.adminOptions))
      //
      //   canAdmin.items = canAdmin.items.filter(
      //     vis => (vis.allow && vis.allow.includes(state.actualRole))
      //   )
      //   // Si hay vistas que mostrar carga el encabezado y las vistas
      //   if (canAdmin.items.length > 0) {
      //     state.options.push(
      //       [
      //         { header: 'Opciones Administrativas de: \n' + state.user.primer_nombre },
      //         { divider: true, inset: true }
      //       ]
      //     )
      //     state.options.push(canAdmin)
      //   }
      // }

      state.drawerOptions = state.options.flat()
    },

    /** Carga la información correspondiente a los proyectos
     * a los que tiene permiso
     */
    set_user_projects (state, data) {
      state.projects = data
    },

    /** Carga el proyecto a usar
     * actualiza las opciones del drawer con los valores respectivos
     */
    set_proyect (state, prjOper) {
      let project = prjOper.project
      let actualOper = prjOper.operation
      let defRoute = null

      state.actualProject = project
      state.actualOperation = actualOper

      state.actualRole = project.rol ? project.rol : 'CL'

      // Si el usuario es admin le da los permisos FIXME
      if (state.user.cedula === 'admin') {
        state.actualRole = 'A'
      }

      state.options = []

      if (state.appConf.back.toolbarMsg) {
        state.options = [
          { header: state.appConf.back.toolbarMsg },
          { divider: true, inset: true }
        ]
      }

      // Elementos en Prueba
      if (state.actualRole === 'A') {
        state.options.push(state.testing)
        state.options.push({ divider: true, inset: true })
      }

      // Debe cargar cuando el rol sea Claudia
      if (state.user.cedula === '24989782') {
        state.options.push(
          {
            title: 'Reporte de Baños',
            icon: 'spa',
            path: '/ik/restrooms'
          }
        )
        state.options.push({ divider: true, inset: true })
      }

      // Si se tienen permisos administrativos
      if ([ 'A', 'OP' ].includes(state.actualRole)) {
        let canAdmin = JSON.parse(JSON.stringify(state.adminOptions))

        canAdmin.items = canAdmin.items.filter(
          vis => (vis.allow && vis.allow.includes(state.actualRole))
        )
        // Si hay vistas que mostrar carga el encabezado y las vistas
        if (canAdmin.items.length > 0) {
          state.options.push(canAdmin)
          state.options.push({ divider: true, inset: true })
        }
      }

      // Si hay un proyecto adiciona vistas de usuario
      if (project) {
        state.options.push(
          [
            { header: 'Reportes para: <br> Proyecto: ' + project.nombre_proyecto + '<br> Operativo: ' + actualOper.nombre_operativo },
            { divider: true, inset: true }
          ]
        )
        // Carga las vistas generales habilitadas para el proyecto y el usuario
        if (project.vistas) {
          let generic = project.vistas
          let keys = Object.keys(project.vistas)
          let canView = JSON.parse(JSON.stringify(state.userOptions))

          canView = canView.filter(
            vis => (keys.includes(vis.title) && !generic[vis.title].includes(state.actualRole))
          )

          // Si hay vistas que mostrar carga el encabezado y las vistas
          if (canView.length > 0) {
            state.options.push(canView)
            defRoute = canView[0].path
          }
        }

        // Carga las vistas especificas habilitadas para el operativo y el usuario, si las tiene
        if (Object.keys(actualOper.vistas).length > 0) {
          let views = JSON.parse(JSON.stringify(actualOper.vistas))

          if (views.items) {
            views = views.items.filter(
              vis => !(vis.ignore && vis.ignore.includes(state.actualRole))
            )
          } else {
            views = views.filter(
              vis => !(vis.ignore && vis.ignore.includes(state.actualRole))
            )
          }

          // Si hay vistas que mostrar carga el encabezado y las vistas
          if (views.length > 0) {
            state.options.push(views)
            if (!defRoute) {
              defRoute = views[0].path
            }
          }
        }
      }

      // Adiciona las vistas al drawer
      state.drawerOptions = state.options.flat()

      // Redirige a la primer ruta valida, sea de lso generales o especificos
      router.push(defRoute)

      // Genera una lista de rutas permitidas para el usuario,
      // dadas las vistas a las que tiene acceso
      let routes = ['/projects']
      state.drawerOptions.forEach(function (element) {
        if (element.path) {
          routes.push(element.path)
        } else if (element.items) {
          element.items.forEach(function (route) {
            if (route.path) {
              routes.push(route.path)
            }
          })
        }
      })
      state.routes = routes

      // FIXME: mejoroar la legibilidad de esta función, descomponiendola
      // console.log('go to set_options')
      // this.set_options(state)
    },

    set_options (state) {
      console.log('set_options')
      state.commit('set_user_options')
      state.commit('set_generic_options')
      state.commit('set_project_options')
    },
    set_user_options (state) {
      console.log('set_project_options')
    },
    set_generic_options (state) {
      console.log('set_project_options')
    },
    set_project_options (state) {
      console.log('set_project_options')
    }
  },

  actions: {
    /** Login de usuario
     * Hace la validación de credenciales ente el back, guarda el token en el store
     * y configura la cabecera para axios.
     *
     * @param {object} context - Context object
     * @param {object} user - Credenciales del usuario
     */
    login (context, user) {
      return new Promise((resolve, reject) => {
        apiaxios.post('/token-auth/', user)
          .then(function (resp) {
            let jwtd = resp.data.token
            context.commit('auth_success', jwtd)
            sessionStorage.setItem('IK', jwtd)
            if (resp.data.token) {
              apiaxios.defaults.headers.common['Authorization'] =
                `${context.state.pretoken} ${resp.data.token}`
            }

            // Solicta el usuario y guarda el valor
            let request = {
              method: 'get',
              url: '/core/users/me/',
              data: {}
            }
            context.dispatch('request_back', request)
              .then(resp => {
                context.commit('set_user_info', resp.data)
              })
              .catch(err => console.log(err))
            resolve(resp)
          }, function (err) {
            context.commit('auth_error', err.response)
            reject(err.response)
          })
      })
    },

    /** Logout de usuario
     * Configura el estado de la sesion a falso y elimina el token tanto del store
     *  como de sessionStorage.
     *
     * @param {object} context - Context object
     */
    logout (context) {
      return new Promise((resolve, reject) => {
        context.commit('logout')
        sessionStorage.clear()
        delete apiaxios.defaults.headers.common['Authorization']
        resolve()
      })
    },

    /** Refresca sesion
     * Actualiza el estado de la sesion
     *
     * @param {object} context - Context object
     */
    refreshSession (context) {
      return new Promise((resolve, reject) => {
        if (context.getters.isLoggedIn) {
          let t = context.getters.getToken
          t = t.split(' ')
          t = t[t.length - 1]
          apiaxios.post('/token-refresh/', { token: t })
            .then(function (resp) {
              let jwtd = resp.data.token
              apiaxios.defaults.headers.common['Authorization'] =
                `${context.state.pretoken} ${resp.data.token}`
              sessionStorage.setItem('IK', jwtd)
              context.commit('auth_success', jwtd)
              resolve(resp.data)
            }, function (err) {
              console.log('ERR:', err.stack)
              context.dispatch('logout')
              console.log('Sesion cerrada - Token expirado', err.response)
              reject(err.response)
            })
        } else {
          context.commit('logout')
        }
      })
    },

    /** Realiza Solicitudes al backend
     * realiza las solicitudes al backend, con los parametros indicados
     * @param  {object} context Objeto de contexto
     * @param  {object} request Parametros de la solicitud
     * @return {promise}        Promesa de datos a entregar o error
     */
    request_back (context, request) {
      return new Promise((resolve, reject) => {
        let u = request.url
        let d = request.data
        let m = request.method
        let p = request.params
        apiaxios({ url: u, data: d, method: m, params: p })
          .then(function (resp) {
            resolve(resp)
          }, function (err) {
            reject(err.stack)
          })
      })
    }
  },

  getters: {
    isLoggedIn: state => state.status,
    getToken: state => {
      if (state.status) return state.pretoken.concat(state.token)
      return state.pretoken.concat('')
    },
    firstRoute: state => state.drawerOptions
  }
})
